import { useApi } from '@omnipresentgroup/api';
import type {
  GetContractorContractOutstandingFeesResponse,
  GetContractorContractOutstandingFeesResponseAPI,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformContractOutstandingFeeFromAPI } from '../mappers';

export const useContractorContractOutstandingFees = ({
  contractorId,
  contractId,
}: {
  contractorId: string;
  contractId: string;
}) => {
  const { GET } = useApi();

  return useQuery<
    GetContractorContractOutstandingFeesResponseAPI,
    unknown,
    GetContractorContractOutstandingFeesResponse
  >({
    queryKey: [API_PATH, contractorId, contractId, 'outstanding-fees'],
    queryFn:
      contractorId && contractId
        ? () =>
            GET<GetContractorContractOutstandingFeesResponseAPI>(
              `${API_BASE}/${API_PATH}/${contractorId}/contracts/${contractId}/outstanding-fees`,
            )
        : () => Promise.reject(new Error('Invalid id to fetch a contractor')),
    enabled: !!contractorId && !!contractId,
    select: (data) =>
      data.map((item) => transformContractOutstandingFeeFromAPI(item)),
  });
};
